<container kind="midi">
  <page-intro-header title="{{ 'NEW_SUBJECT.TITLE' | translate }}" back="/subjects">
  </page-intro-header>
  <mat-card class="card">
    <subject-form *ngIf="!isServiceProviderUser" [importedSubjectData]="importedSubjectData"></subject-form>
    <service-provider-subject-form *ngIf="isServiceProviderUser"></service-provider-subject-form>
  </mat-card>
</container>